import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, RouteProps, withRouter } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import ArrowIcon from "sweet-web/components/icons/ArrowIcon";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import { SendMessage } from "sweet-web/redux/chat/actions";

const Wrapper = styled.form<{ focused: boolean }>`
  width: 100%;
  border: 1px solid ${colors.lightGray};
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  position: relative;
  box-shadow: ${props =>
    props.focused ? ` rgba(0, 0, 0, 0.08) 0 3px 10px 0` : "none"};
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
  }
`;

const NewMessageInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  padding: 10px 50px 10px 15px;
  font-size: 14px;
  font-weight: 500;
  color: ${colors.nearBlack};
  background: none;
`;

const NewMessageButton = styled.button`
  position: absolute;
  right: 0px;
  outline: none;
  border: none;
  padding: 10px 15px;
  margin-top: 2px;
  background: none;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  &:hover {
    transform: scale(1.02);
  }
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const NewMessageBar: React.FC<Props> = props => {
  const { chatId } = props.match.params as { chatId: string };

  const [newMessage, setNewMessage] = useState("");
  const [sendMessageHover, setSendMessageHover] = useState(false);
  const [sendMessageFocus, setSendMessageFocus] = useState(true);

  if (!chatId) return null;

  const sendMessage = e => {
    e.preventDefault();
    props.SendMessage(newMessage, chatId);
    setNewMessage("");
  };

  const onInputChange = e => {
    setNewMessage(e.target.value);
  };

  return (
    <Wrapper focused={sendMessageFocus} onSubmit={sendMessage}>
      <NewMessageInput
        placeholder="Send a Message"
        value={newMessage}
        onChange={onInputChange}
        onFocus={() => setSendMessageFocus(true)}
        onBlur={() => setSendMessageFocus(false)}
        autoComplete="off"
        autoFocus={true}
      />
      <NewMessageButton
        type="submit"
        onMouseOver={() => setSendMessageHover(true)}
        onMouseLeave={() => setSendMessageHover(false)}
      >
        <ArrowIcon
          size={20}
          color={sendMessageHover ? colors.primary : colors.gray}
        />
      </NewMessageButton>
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  return {};
};
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      SendMessage
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default withRouter(connector(NewMessageBar));
